import React, { useEffect, useState } from "react";
import { CardDeck, Form, FormControl, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import logger from "../../../../utils/logger";
import {
    getRemedies,
    loadRemedies
} from "../../../controller/reducer/remedies";
import { getLoading } from "../../../controller/reducer/ui";
import TagSelector from "../common/tag-selector";
import RemedyCard from "./card";
import "./styles.css";

function check(title, tags, search, searchTags) {
  if (title.toLowerCase().includes(search)) {
    if (searchTags.length === 0) return true;
    for (let i = 0; i < searchTags.length; i++) {
      if (tags.includes(searchTags[i].value)) {
        return true;
      }
    }
  }
  for (let i = 0; i < tags.length; i++) {
    if (search.includes(tags[i])) {
      return true;
    }
  }
  return false;
}

function Remedies() {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [tags, setTags] = useState([]);

  const _remedies = useSelector(getRemedies);
  const [remedies,setRemedies] = useState(_remedies);
  logger()(remedies);

  useEffect(() => {
    setRemedies(_remedies
      .filter((res) => check(res.title, res.tags, search, tags)))
  }, [_remedies,search,tags])

  useEffect(() => {
    dispatch(loadRemedies());
  }, [dispatch]);

  if (useSelector(getLoading))
    return (
      <Spinner
              style={{ position: "fixed", top: "50%", right: "47%" }}
        animation="border"
      />
    );

  return (
    <div>
      <Form inline type="submit" className="ml-4 mr-4 mt-4">
        <FormControl
          type="text"
          placeholder="Search"
          className="flex-grow-1"
          value={search}
          onChange={(e) => setSearch(e.currentTarget.value.toLowerCase())}
        />
      </Form>
      <div className="ml-4 mr-4 mt-4">
        <TagSelector isRemedy={true} tags={tags} setTags={setTags} />
      </div>

      {remedies.length > 0 ? (
        <CardDeck className="m-4 justify-content-between">
          {remedies
            .filter((remedy) => check(remedy.title, remedy.tags, search, tags))
            .map((remedy, id) => (
              <RemedyCard key={id} remedy={remedy} dispatch={dispatch} />
            ))}
        </CardDeck>
      ) : (
        <p className="ml-4 mr-4 mt-4 font-weight-normal">No Resources Found</p>
      )}
    </div>
  );
}

export default Remedies;
